export var ActivationStatusType;
(function (ActivationStatusType) {
    ActivationStatusType["NoActivation"] = "NoActivation";
    ActivationStatusType["Pending"] = "Pending";
    ActivationStatusType["InProgress"] = "InProgress";
    ActivationStatusType["Executed"] = "Executed";
    ActivationStatusType["Success"] = "Success";
    ActivationStatusType["Failed"] = "Failed";
    ActivationStatusType["Skipped"] = "Skipped";
})(ActivationStatusType || (ActivationStatusType = {}));
//# sourceMappingURL=activation-status.const.js.map